export default "__VITE_ASSET__DZ$OAYOJ__"